<template>
  <div>
    <div class="list-title">
      <div class="item-left">排名</div>
      <div class="item-center">学校</div>
      <div class="item-right">事件响应率</div>
    </div>
    <div class="school-grade-list">
      <div
        class="list-item"
        v-for="(item, index) in weekRate"
        :key="index"
      >
        <div class="item-left">
          <img
            v-if="item.rate_index == 1"
            class="item-left-img"
            src="@/assets/img/safepostureSchool2/rank-1.png"
            alt=""
          />
          <img
            v-if="item.rate_index == 2"
            class="item-left-img"
            src="@/assets/img/safepostureSchool2/rank-2.png"
            alt=""
          />
          <img
            v-if="item.rate_index == 3"
            class="item-left-img"
            src="@/assets/img/safepostureSchool2/rank-3.png"
            alt=""
          />
          <span v-if="item.rate_index > 3">NO.{{ item.rate_index }}</span>
        </div>
        <el-tooltip
          class="item item-center"
          effect="light"
          :content="item.school_name"
          placement="top"
        >
          <div
            style="text-overflow:ellipsis;white-space: nowrap; overflow:hidden;"
          >
            {{ item.school_name }}
          </div>
        </el-tooltip>
        <div class="item-right">{{ item.event_resp_rate }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "schoolRate",
  data() {
    return {
      myChart: {}
    };
  },
  props: {
    weekRate: {
      type: Array,
      default: {
        return: []
      }
    }
  },
  created() {},
  mounted() {
    let _this = this;
    // window.onresize = function() {
    //     _this.myChart.resize()
    // }
  },
  methods: {},
  watch: {
    // echartsData: function(nval) {
    //   this.loadEchart();
    // }
  }
};
</script>

<style lang="scss" scoped>
.list-title {
  margin: 0 auto;
  width: 90%;
  margin-top: 16px;
  height: 26px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .item-left {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20%;
    color: #6ff3fa;
    font-size: 16px;
  }
  .item-center {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    color: #6ff3fa;
    font-size: 16px;
  }
  .item-right {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30%;
    color: #6ff3fa;
    font-size: 16px;
  }
}
.school-grade-list {
  margin: 0 auto;
  width: 90%;
  height: 220px;
  overflow-y: scroll;
  scrollbar-width: none;
  padding-bottom: 10px;
  .list-item {
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    background: url("~@/assets/img/safepostureSchool2/list-li-bg.png") center
      center no-repeat;
    background-size: 100% 100%;
    height: 46px;
    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(3) {
      height: 46px;
    }
    .item-left {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 20%;
      color: #cecece;
      font-size: 16px;
      line-height: 28px;
    }
    .item-center {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50%;
      color: #cecece;
      font-size: 16px;
      line-height: 28px;
    }
    .item-right {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 30%;
      color: #cecece;
      font-size: 16px;
      line-height: 28px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}
</style>
